export const selectBrand = ({brand}) => brand;
export const selectMain = ({ main }) => main;
export const selectCategory = ({ category }) => category;
export const selectSearch = ({ searchPage }) => searchPage
export const clearCategoryData = () => ({
    type: 'CLEAR_CATEGORY_DATA',
  });